<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 48 48"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M8.184 17.024H39v-4.878a3 3 0 0 0-3-3h-2.31v2.811a1.262 1.262 0 0 1-2.525 0v-2.81H16.019v2.81a1.262 1.262 0 0 1-2.524 0v-2.81h-2.31a3 3 0 0 0-3 3v4.877zm0 2v15.561a3 3 0 0 0 3 3H36a3 3 0 0 0 3-3v-15.56H8.184zM16.02 7.146h15.146V5.604a1.262 1.262 0 1 1 2.524 0v1.542H36a5 5 0 0 1 5 5v22.44a5 5 0 0 1-5 5H11.184a5 5 0 0 1-5-5v-22.44a5 5 0 0 1 5-5h2.311V5.604a1.262 1.262 0 1 1 2.524 0v1.542zm3.525 16.22h1.786a1 1 0 0 1 1 1v1.805a1 1 0 0 1-1 1h-1.786a1 1 0 0 1-1-1v-1.805a1 1 0 0 1 1-1zm6.31 0h1.787a1 1 0 0 1 1 1v1.805a1 1 0 0 1-1 1h-1.787a1 1 0 0 1-1-1v-1.805a1 1 0 0 1 1-1zm6.311 0h1.786a1 1 0 0 1 1 1v1.805a1 1 0 0 1-1 1h-1.786a1 1 0 0 1-1-1v-1.805a1 1 0 0 1 1-1zm-18.932 6.341h1.786a1 1 0 0 1 1 1v1.805a1 1 0 0 1-1 1h-1.786a1 1 0 0 1-1-1v-1.805a1 1 0 0 1 1-1zm6.31 0h1.787a1 1 0 0 1 1 1v1.805a1 1 0 0 1-1 1h-1.786a1 1 0 0 1-1-1v-1.805a1 1 0 0 1 1-1zm6.311 0h1.787a1 1 0 0 1 1 1v1.805a1 1 0 0 1-1 1h-1.787a1 1 0 0 1-1-1v-1.805a1 1 0 0 1 1-1z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
